import { SwiperContainer } from './RoundThumbnailCard';
import Image from '../Image';
import DatabaseLayerPopup from '../Layer/DatabaseLayerPopup';
import SwiperOverflowHidden from '../Swiper/SwiperOverflowHidden';
import { Tit } from '../Titles';
import IcoBook from '@/assets/img/icons/ico_book_gray@2x.png';
import IcoDown from '@/assets/img/icons/ico_down_gray@2x.png';
import IcoLetter from '@/assets/img/icons/ico_letter_gray@2x.png';
import NullImage1 from '@/assets/img/tmp/no_img1@2x.png';
import NullImage2 from '@/assets/img/tmp/no_img2@2x.png';
import Simg from '@/assets/img/tmp/what-we-do/database_s_img1@2x.jpg';
import Button from '@/components/Button';
import { breakpoint } from '@/helpers/BreakpointHelper';
import { usePopupStore } from '@/stores/PopupStore';
import { useUserStore } from '@/stores/UserStore';
import dayjs from 'dayjs';
import { navigate } from 'gatsby';
import { observer } from 'mobx-react-lite';
import React, { ImgHTMLAttributes, useState } from 'react';
import styled from 'styled-components';
import SwiperCore, { A11y, Navigation, Scrollbar } from 'swiper';
import { SwiperSlide } from 'swiper/react';

SwiperCore.use([Navigation, Scrollbar, A11y]);

interface NewsProps {
  data: GatsbyTypes.PublicationListPageQuery['latest']['nodes'];
  img?: boolean;
}

export interface DataItem {
  id?: string | number;
  image?: ImgHTMLAttributes<any>['src'];
  pcImage?: ImgHTMLAttributes<any>['src'];
  mobileImage?: ImgHTMLAttributes<any>['src'];
  title?: string | undefined;
  ebook?: string;
  download?: string;
  letter?: boolean;
}
const NewsImage = styled.div<NewsProps>`
  overflow: hidden;
  position: relative;

  .img-box {
    width: 100%;
    padding-top: 136.46%;
  }

  .card-img {
    max-width: 100%;
    width: 100%;
  }

  .img-box,
  .card-img {
    transition: transform 1.2s;
  }
  &::before {
    content: '';
    display: block;
    position: absolute;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    z-index: 1;
    border: 0px solid transparent;
    transition: border 0.2s;
  }
`;

const Hover = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  top: 35px;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  display: none;
  z-index: 1;

  nav {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    justify-content: space-between;

    .btn-ico {
      display: block;
      width: 56px;
      height: 56px;
      background-size: 24px;
      background-position: center;
      background-repeat: no-repeat;
      border-radius: 1px;
      border: 1px solid #b7b8ba;
      background-color: #fff;
      margin: 0 8px;
      cursor: pointer;

      &.i1 {
        background-image: url(${IcoBook});
      }
      &.i2 {
        background-image: url(${IcoDown});
      }
      &.i3 {
        background-image: url(${IcoLetter});
      }
    }
  }
`;
const NewsBody = styled.div`
  padding-top: 17px;

  strong {
    display: inline-block;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    text-align: center;
    line-height: 1.6;
  }

  ${breakpoint(`tablet`)} {
    padding-top: 16px;
    strong {
      max-height: 50px;
    }
  }
`;

const Card = styled.div`
  .card-top {
    position: relative;
    padding-top: 35px;
    cursor: pointer;

    &:hover {
      ${Hover} {
        display: block;
      }
    }
    .new-txt {
      display: block;
      width: 72px;
      line-height: 72px;
      text-align: center;
      color: #fff;
      border-radius: 100%;
      background: #f26a21;
      position: absolute;
      right: 0;
      top: 0;
      text-transform: uppercase;
      z-index: 2;
    }
  }
`;
const SwiperCustom = styled(SwiperOverflowHidden)<NewsProps>`
  padding: 0;

  .swiper-container {
    padding-bottom: 83px;
    width: auto;

    ${({ btn }) => `padding-bottom: 117px;`}
  }
  .swiper-scrollbar {
    max-width: 100%;
    width: auto;
    left: 0;
    right: 0;
    margin-left: 0;
    bottom: 0;
    transform: translate(0, 0);

    ${({ btn }) => `
      right: 202px; 
      bottom: 36px;
    `}
  }

  .swiper-button-prev,
  .swiper-button-next {
    display: none;
    bottom: 10px;
    margin: 0;
    ${({ btn }) => `display: block;`}
  }
  .swiper-button-prev {
    right: 96px;
  }
  .swiper-button-next {
    right: 16px;
  }

  .swiper-slide {
    overflow: hidden;
    width: 288px;
    // margin-right: 128px;
    & + .swiper-slide {
      margin-left: 0 !important;
    }

    &:last-child {
      margin-right: 0;
    }

    ${NewsImage} {
      background: url(${NullImage1}) center no-repeat;
      background-size: cover;
    }
    .link-item {
      display: block;
      width: 100%;
    }

    &:nth-child(2n + 0) {
      ${NewsImage} {
        background-image: url(${NullImage2});
      }
    }
  }

  ${breakpoint(`tablet`)} {
    .swiper-container {
      padding-bottom: 40px;
    }

    .swiper-scrollbar {
      left: 12px;
      right: 12px;
    }
    .swiper-button-prev,
    .swiper-button-next {
      display: none;
    }
  }
  ${breakpoint(`mobile`)} {
  }
`;

const DatabaseCard: React.FC<NewsProps> = observer(({ data, img }) => {
  const date = new Date();
  const year = date.getFullYear();
  const month = `0${1 + date.getMonth()}`.slice(-2);
  const day = `0${date.getDate()}`.slice(-2);
  const today = year + month + day;

  let image = data.imgAttGrpNoTn;
  if (image === undefined || image.indexOf(`null`) !== -1) {
    image = Simg;
  }

  const userStore = useUserStore();
  const popupStore = usePopupStore();
  const [popupOpen, setPopupOpen] = useState(false);
  const [PopupSid, setPopupSid] = useState<PopupData | string | number>(``);
  const [PopupTitle, setPopupTitle] = useState(``);
  const [PopupCnt, setPopupCnt] = useState(``);

  return (
    <>
      <SwiperCustom>
        <SwiperContainer
          scrollbar={{ draggable: false }}
          slidesPerView="auto"
          navigation={false}
          allowTouchMove={false}
          breakpoints={{
            1024: {
              slidesPerView: 3,
              allowTouchMove: false,
              spaceBetween: 128,
            },
            640: {
              slidesPerView: 2,
              allowTouchMove: true,
              spaceBetween: 40,
            },
            320: {
              slidesPerView: 1,
              allowTouchMove: true,
              spaceBetween: 0,
            },
          }}
        >
          {data.map((row) => (
            <SwiperSlide key={row.boardIndexNumber}>
              <Card>
                <div className="card-top">
                  {today - dayjs(row.firstRegisterDate).format(`YYYYMMDD`) <=
                  7 ? (
                    <span className="new-txt">new</span>
                  ) : null}
                  <NewsImage>
                    {img ? (
                      <Image
                        className="card-img"
                        pcSrc={row.imgAttGrpNoTn}
                        mobileSrc={row.imgAttGrpNoTn}
                      />
                    ) : (
                      <div
                        className="img-box"
                        css={`
                          background-image: url(${row.imgAttGrpNoTn});
                        `}
                      />
                    )}
                  </NewsImage>
                  <Hover>
                    <nav>
                      {row.referUrl !== null && row.referUrl !== `` && (
                        <a
                          href={`${process.env.BACKEND_URL}${row.referUrl}`}
                          target="_blank"
                          rel="noreferrer"
                        >
                          <Button size="sm" className="btn-ico i1">
                            <span className="a11y">eBook</span>
                          </Button>
                        </a>
                      )}
                      {row.arrAttFile?.length &&
                        (userStore.isLoggedIn()
                          ? row.arrAttFile.map((file) => (
                              <li>
                                <a href={file.downloadUrl}>
                                  <Button
                                    to={file.downloadUrl}
                                    size="sm"
                                    className="btn-ico i2"
                                    key={file.indexNumber}
                                  >
                                    <span className="a11y">다운로드</span>
                                  </Button>
                                </a>
                              </li>
                            ))
                          : row.arrAttFile.map((file) => (
                              <li>
                                <Button
                                  size="sm"
                                  type="button"
                                  className="btn-ico i2"
                                  onClick={() => {
                                    popupStore.show(
                                      `로그인 후에 신청 가능합니다.`,
                                      {
                                        onConfirm: () =>
                                          navigate(
                                            `/auth/login?redirectTo=/what-we-do/database`,
                                          ),
                                      },
                                    );
                                  }}
                                >
                                  <span className="a11y">다운로드</span>
                                </Button>
                              </li>
                            )))}
                      {row.optData1 === `Y` &&
                        (userStore.isLoggedIn() ? (
                          <Button
                            size="sm"
                            type="button"
                            onClick={() => {
                              setPopupOpen(true);
                              setPopupSid(row.boardIndexNumber);
                              setPopupTitle(row.subject);
                              setPopupCnt(row.optData2);
                            }}
                            className="btn-ico i3"
                          >
                            <span className="a11y">우편신청</span>
                          </Button>
                        ) : (
                          <Button
                            size="sm"
                            type="button"
                            onClick={() => {
                              popupStore.show(`로그인 후에 신청 가능합니다.`, {
                                onConfirm: () =>
                                  navigate(
                                    `/auth/login?redirectTo=/what-we-do/database`,
                                  ),
                              });
                            }}
                            className="btn-ico i3"
                          >
                            <span className="a11y">우편신청</span>
                          </Button>
                        ))}
                    </nav>
                  </Hover>
                </div>
                <NewsBody>
                  <Tit
                    size="s4-1"
                    dangerouslySetInnerHTML={{ __html: row.subject }}
                  />
                </NewsBody>
              </Card>
            </SwiperSlide>
          ))}
        </SwiperContainer>
        {popupOpen && (
          <DatabaseLayerPopup
            isOpen={popupOpen}
            PopSid={PopupSid}
            PopTitle={PopupTitle}
            PopCnt={PopupCnt}
            onRequestClose={() => setPopupOpen(false)}
          />
        )}
      </SwiperCustom>
    </>
  );
});

export default DatabaseCard;
